import { render, staticRenderFns } from "./QSiNoNoAplica.vue?vue&type=template&id=63807e26&scoped=true"
import script from "./QSiNoNoAplica.vue?vue&type=script&lang=js"
export * from "./QSiNoNoAplica.vue?vue&type=script&lang=js"
import style0 from "./QSiNoNoAplica.vue?vue&type=style&index=0&id=63807e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63807e26",
  null
  
)

export default component.exports